import * as log from '../common/js/appLogger';
//import {ISessionHandler} from './ISessionHandler'
import * as util from '../common/js/util';
export class Config {
	static readonly VERSION = '2.0.3.29';

	//static readonly OVERRIDE_SCHEME:string  = "DEV"  //if empty, it will check util.isDev() etc checking

	static readonly PASSPORT_PLAN_DEPOSIT = 1000;
	static readonly PASSPORT_HOMETEL_DEPOSIT = 1000;

	static readonly CASH_PLAN_DEPOSIT = 1500;
	static readonly CASH_HOMETEL_DEPOSIT = 360;

	//==============================================

	static readonly SERVER_CHECK_PREPROD: RegExp = /shopstage.smartone.com/;
	static readonly SERVER_CHECK_PROD: RegExp = /www.smartone.com/;
	static readonly SERVER_CHECK_STAGING: RegExp = /webstage|waptest|testcloudstorage|wwwtest/;

	static readonly GTM_ID_PROD: string = 'GTM-PVJVH9S';
	static readonly GTM_ID_DEV: string = 'GTM-PVJVH9S'; //'GTM-KNG5KH7'

	static readonly FLAG_VIDEO_PLAY: string = 'videoPlayFlag';
	static readonly FLAG_DEFAULT_APPLY_PROMO: string = 'defaultApplyPromoFlag';
	static readonly STORED_PROMO_CODE: string = 'appliedPromoCode';
	static readonly FLAG_SCROLL_TO_PLAN: string = 'scrollToPlanSelection';

	static readonly PATHNAME_A1A: string = 'InternetExperienceTips';

	//==============================================

	static appmode: string; //for developer reference only
	static env: string; //for api param "environment"
	static enableGA: boolean;
	static enableGTM: boolean;
	static useMockupApi: boolean;
	static removeUrlParams: boolean;
	static enabledMissingFieldPage: boolean;
	static enableLiveChat: boolean;
	static GTM_ID: string = '';

	static supportOffline: boolean; //offline portal implementation
	static supportReCaptcha: boolean;
	static supportPromoCode: boolean;
	static supportIPad: boolean; // ipad offer implementation
	static skipAddChk: boolean; // need to check address and coverage
	static showVideoMainSection: boolean;
	static printLog: number; //0 = debug, > info > error
	static promptErrorToConsole: boolean; // not prompt error, show to console log instead.
	static specialHandleHasePlan: boolean;

	static theme: string; //for setting header theme

	static gaId: string;
	static pathname: string;
	static filepathname: string;
	static urlPath: string;

	static pcMaxWidth: number;
	static mobileMaxWidth: number;

	static setup(): void {
		Config.supportOffline = false; // TODO: change to true if new portal support offline
		Config.supportReCaptcha = true;
		Config.supportPromoCode = true;
		Config.supportIPad = false; // 2022-09-02: hide this addon
		Config.skipAddChk = true; // 2022-01-24: remove address bar
		Config.showVideoMainSection = true; // 20221124 show
		Config.specialHandleHasePlan = true; // 2022-10-31: change plan code & vas code according to mand-offer selected

		Config.theme = '';

		if (util.isLocal()) {
			this.loadLocal();
		} else if (util.isDev()) {
			this.loadDEV();
		} else if (util.isStg()) {
			this.loadStg();
		} else if (util.isPreProd()) {
			this.loadPreprod();
		} else if (util.isProd()) {
			this.loadProd();
		}

		log.ot('APP VERSION', Config.VERSION);
	}

	private static loadLocal() {
		Config.appmode = 'LOCAL';
		Config.enableGA = true;
		Config.enableGTM = false;
		Config.GTM_ID = Config.GTM_ID_DEV;

		Config.useMockupApi = true;
		Config.env = 'local';
		// debug dev api (dummy one) in localhost
		//Config.env = "staging"
		//Config.useMockupApi = false

		Config.enabledMissingFieldPage = true; // false  //
		Config.enableLiveChat = false;
		Config.printLog = 0;
		Config.removeUrlParams = false;
		Config.pcMaxWidth = 1440;
		Config.mobileMaxWidth = 959;
		Config.promptErrorToConsole = false;

		Config.gaId = 'UA-112311459-11';
		Config.pathname = '/5gbb';
		Config.filepathname = '/5gbb';
		Config.urlPath = '/Home5GBroadband/';

		// uncomment them when build version to eclipse's jsp project:
		Config.pathname = '/5gbb/Home5GBroadband/web';
		Config.filepathname = '/5gbb/Home5GBroadband/web';

		log.it('Config', 'loadLocal');
	}

	protected static loadDEV() {
		Config.appmode = 'DEV';
		Config.env = 'staging';
		Config.enableGA = true;
		Config.enableGTM = false;
		Config.GTM_ID = Config.GTM_ID_DEV;
		Config.useMockupApi = false; // set true if need to run dummy json data in dev.vaka.com
		Config.enableLiveChat = false;
		Config.removeUrlParams = false;
		Config.printLog = 0;
		Config.pcMaxWidth = 1440;
		Config.mobileMaxWidth = 959;
		Config.promptErrorToConsole = true;
		Config.enabledMissingFieldPage = false;

		Config.gaId = 'UA-20788189-5';
		Config.pathname = '/Home5GBroadband/Home5GBroadband/web';
		Config.filepathname = '/Home5GBroadband/Home5GBroadband/web';
		Config.urlPath = '/Home5GBroadband/';

		log.it('Config', 'loadDEV');
	}

	protected static loadStg() {
		Config.appmode = 'STG';
		Config.env = 'staging';
		Config.enableGA = true;
		Config.enableGTM = false;
		Config.GTM_ID = Config.GTM_ID_PROD;
		Config.useMockupApi = false;
		Config.enableLiveChat = true;
		Config.removeUrlParams = false;
		Config.printLog = 1;
		Config.pcMaxWidth = 1440;
		Config.mobileMaxWidth = 959;
		Config.promptErrorToConsole = true;
		Config.enabledMissingFieldPage = false;
		// TODO: need to update after they are ready
		Config.gaId = 'UA-20788189-5';
		Config.pathname = '/Home5GBroadband/web';
		Config.filepathname = '/Home5GBroadband/web';
		Config.urlPath = '/Home5GBroadband/';

		log.it('Config', 'loadSTG');
	}

	protected static loadPreprod() {
		Config.appmode = 'PRE-PROD';
		Config.env = 'pre-production';
		Config.enableGA = true;
		Config.enableGTM = false;
		Config.GTM_ID = Config.GTM_ID_PROD;
		Config.useMockupApi = false;
		Config.enableLiveChat = true;
		Config.removeUrlParams = false;
		Config.printLog = 1;
		Config.pcMaxWidth = 1440;
		Config.mobileMaxWidth = 959;
		Config.promptErrorToConsole = true;
		Config.enabledMissingFieldPage = false;

		// TODO: need to update after they are ready
		Config.gaId = 'UA-20788189-5';
		Config.pathname = '/Home5GBroadband/web';
		Config.filepathname = '/Home5GBroadband/web';
		Config.urlPath = '/Home5GBroadband/';

		log.it('Config', 'loadPreProd');
	}

	protected static loadProd() {
		Config.appmode = 'PROD';
		Config.env = 'production';
		Config.enableGA = true;
		Config.enableGTM = false;
		Config.GTM_ID = Config.GTM_ID_PROD;
		Config.useMockupApi = false;
		Config.enableLiveChat = true;
		Config.removeUrlParams = false;
		Config.printLog = 1;
		Config.pcMaxWidth = 1440;
		Config.mobileMaxWidth = 959;
		Config.promptErrorToConsole = true;
		Config.enabledMissingFieldPage = false;
		// TODO: need to update after they are ready
		Config.gaId = 'UA-20788189-5';
		Config.pathname = '/Home5GBroadband/web';
		Config.filepathname = '/Home5GBroadband/web';
		Config.urlPath = '/Home5GBroadband/';

		log.it('Config', 'loadProd');
	}
}
